// We need jQuery
var $ = window.jQuery;

export default function() {
  var dateStart = $('#dates .start-date input.input').val()
  dateStart = dateStart.replace(/-/g, ' ')
  dateStart = Date.parse(dateStart)

  var dateEnd = $('#dates .end-date input.input').val();
  dateEnd = dateEnd.replace(/-/g, ' ')
  dateEnd = Date.parse(dateEnd)

  if ($('#dates .start-date input').val() && $('#dates .end-date input').val()) {
    var nights = Math.round((dateEnd - dateStart) / 1000 / 60 / 60 / 24);
    if (nights < 0) {
      $('#nights input').val('End is before start!');
    } else {
      $('#nights input').val(nights);
    }
  }
}
